let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fGjDp")).then(() => parcelRequire('6AoJr'));